
import { Linkedin, Twitter, Facebook, Github, ExternalLink } from "lucide-react";

interface SocialLinkProps {
  platform: string;
  url?: string;
}

export const SocialLink: React.FC<SocialLinkProps> = ({ platform, url }) => {
  if (!url) return null;

  let IconComponent;
  switch (platform.toLowerCase()) {
    case 'linkedin': IconComponent = Linkedin; break;
    case 'twitter': IconComponent = Twitter; break;
    case 'facebook': IconComponent = Facebook; break;
    case 'github': IconComponent = Github; break;
    default: IconComponent = ExternalLink;
  }

  return (
    <a href={url.startsWith('http') ? url : `https://${url}`} target="_blank" rel="noopener noreferrer" className="text-sm text-blue-600 hover:underline dark:text-blue-400 flex items-center">
      <IconComponent className="w-4 h-4 mr-1" /> {platform.charAt(0).toUpperCase() + platform.slice(1)}
    </a>
  );
};
